export namespace VikingMaltCalculator {
    export interface IConstantProps {
        variety?: string | undefined;
        cropYear?: string | undefined;
        resultCount?: number | undefined
    }

    export interface IParameterProperties {
        id: string;
        sp: number | null;
        min: number | null;
        max: number | null;
    }

    export interface IParametersData {
        parameters: IParameterProperties[];
        constants: IConstantProps;
    }

}